import { useEffect } from "react";
import { Routes, Route, useNavigate, useLocation } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import AOS from "aos";
import "aos/dist/aos.css";
import { useDispatch, useSelector } from "react-redux";
import { checkAutoLogin } from "./services/AuthService";
import Navbar from "./Pages/Navbar";
import Home from "./Pages/Home";
import Footer from "./Pages/Footer";
import Products from "./Pages/Products";
import ScrollToTop from "./common/ScrollToTop";
import Product from "./Pages/Product";
import Error404 from "./common/Error404";
import Cart from "./Pages/Cart";
import Checkout from "./Pages/Checkout";
import Profile from "./Pages/Profile";
import "./i18n";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "./App.css";
import "react-toastify/dist/ReactToastify.css";
import OrderFailed from "./common/OrderFailed";
import OrderSuccessful from "./common/OrderSuccessful";
import Static from "./Pages/Static";
import Categories from "./Pages/Categories";
import LandingPage from "./Pages/LandingPage";
import OurProducts from "./Pages/OurProducts";
import Category from "./Pages/Categories/Category";
import Authentication from "./Pages/Authentication";

function App() {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const location = useLocation();
	const lang = useSelector((state) => state?.lang?.lang);

	useEffect(() => {
		AOS.init();
		checkAutoLogin(dispatch, navigate, location?.pathname);
	}, []);

	return (
		<div className={`App ${lang}`}>
			<ToastContainer />
			<ScrollToTop />
			<div style={{ minHeight: "50vh" }}>
				{location?.pathname === "/landing-page" ? (
					<Routes>
						<Route path="/landing-page" element={<LandingPage />} />
					</Routes>
				) : (
					<div className="home-page">
						<Navbar />
						<Routes>
							<Route path="/" element={<Home />} />
							<Route path="/login" element={<Authentication />} />
							<Route path="/sign-up" element={<Authentication />} />
							<Route path="/our-products" element={<OurProducts />} />
							<Route path="/products" element={<Products />} />
							<Route path="/categories" element={<Categories />} />
							<Route path="/category/:id" element={<Category />} />
							<Route path="/best-seller" element={<Category />} />
							<Route path="/products/product/:id" element={<Product />} />
							<Route path="/about-us" element={<Static />} />
							<Route path="/privacy-policy" element={<Static />} />
							<Route path="/terms-conditions" element={<Static />} />
							<Route path="/cart" element={<Cart />} />
							<Route path="/checkout" element={<Checkout />} />
							<Route path="/profile" element={<Profile />} />

							<Route path="/order-successful" element={<OrderSuccessful />} />
							<Route path="/order-failed" element={<OrderFailed />} />
							<Route path="*" element={<Error404 />} />
						</Routes>
						<Footer />
					</div>
				)}
			</div>
		</div>
	);
}

export default App;
